import { render, staticRenderFns } from "./CSlotNav.vue?vue&type=template&id=fa94c9ba&"
import script from "./CSlotNav.vue?vue&type=script&lang=ts&"
export * from "./CSlotNav.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports